<template>
    <div>
        <v-overlay :value="value" :key="0">
            <Dialog v-bind:value="value" @input="$emit('input', $event)"
                    :title="(siteDetails && siteDetails.Site ? siteDetails.Site.Name : 'Seite') + ' bearbeiten'"
                    width="500px"
                    @click:outside="close"
                    @cancel="close" class="editSiteDialog"
                    @ok="submit" replace-buttons
                    fullscreen :scrollTrigger="vuexState.loading.site"
                    transition="dialog-bottom-transition" :scrollable="true"
                    :loading="loading"
            >
                <transition name="fade" mode="out-in">
                    <div v-if="vuexState.loading.site" class="d-flex justify-center align-center" style="height: 55vh">
                        <v-progress-circular :size="50" :color="ada.pink" indeterminate></v-progress-circular>
                    </div>
                    <form v-else>
                        <v-row>
                            <v-col class="label" cols="12" sm="6">
                                <div class="mb-3 d-flex align-baseline">
                                    <div class="text-body-1 pr-4">Umgebung:</div>
                                    <div class="ml-4 d-flex" style="position: relative; top:4px;">
                                        <v-checkbox v-model="isDisplay" label="Display" class="mt-0" :color="ada.blue"
                                                    :class="{'mr-14': env_errors.length === 0}"
                                                    :true-value="1" :false-value="0" hide-details="auto"
                                                    @change="$v.env.$touch()" :error-messages="env_errors"></v-checkbox>
                                        <v-checkbox v-model="isVideo" label="Video" :color="ada.blue"
                                                    :error-messages="env_errors"
                                                    :true-value="1" :false-value="0" class="mt-0 isVideoCbx"
                                                    hide-details="auto"
                                                    @change="$v.env.$touch()"></v-checkbox>
                                    </div>
                                </div>
                                <Toggle v-model="usesAdaBundle" label="auf MoltenBundle umgestellt"></Toggle>
                                <Input v-model="name" label="Bezeichnung" :style="styles"
                                       :error-messages="name_errors" :required="true"
                                       @input="$v.name.$touch()"
                                       @blur="$v.name.$touch()"
                                ></Input>
                                <Dropdown v-model="selected_publisher" :items="publisher" label="Publisher"
                                          :style="styles"
                                          :error-messages="publisher_errors" item-text="Name" item-value="Name"
                                          @input="$v.selected_publisher.$touch()" @blur="$v.selected_publisher.$touch()"
                                ></Dropdown>
                                <v-slide-y-transition>
                                    <div v-if="isDisplay === 1">
                                        <Dropdown v-model="default_sitetype" :items="sitetypes" label="Default Sitetype"
                                                  :style="styles"
                                                  :error-messages="sitetype_errors" item-text="Name" item-value="Name"
                                                  @input="$v.default_sitetype.$touch()"
                                                  @blur="$v.default_sitetype.$touch()"
                                        >
                                            <template #append-outer>
                                                <TooltipIcon :color="ada.blue" :fab="true" :xsmall="true"
                                                             tooltip="Sitetype hinzufügen"
                                                             @click="showAddSitetypeDialog = true"
                                                >mdi-plus
                                                </TooltipIcon>
                                            </template>
                                        </Dropdown>

                                    </div>
                                </v-slide-y-transition>
                                <Dropdown v-model="default_opt_in" :items="opt_in_options" label="OptIn Verhalten"
                                          :error-messages="opt_in_errors" :style="styles"
                                          @input="$v.default_opt_in.$touch()" @blur="$v.default_opt_in.$touch()"
                                ></Dropdown>
                                <Dropdown v-for="(dropdown, i) in formDropdowns" :key="'dropdown_'+i"
                                          v-model="$v[dropdown.vModel].$model" :items="dropdown.items"
                                          :label="dropdown.label" :style="styles"
                                          :error-messages="dropdown.errors"
                                          :item-text="dropdown.itemText ? dropdown.itemText : 'text'"
                                          :item-value="dropdown.itemText ? dropdown.itemText : 'value'"
                                          @input="$v[dropdown.vModel].$touch()"
                                          @blur="$v[dropdown.vModel].$touch()"
                                ></Dropdown>
                                <v-row no-gutters v-for="(switches, i) in formSwitches" :key="'switch_'+i">
                                    <v-col class="label" cols="4">{{ switches.label }}</v-col>
                                    <v-col>
                                        <Toggle
                                            class="ma-0"
                                            v-model="$v[switches.vModel].$model"
                                            :error-messages="switches.errors"
                                        ></Toggle>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div style="margin-top:5em">
                                    <h2 class="mb-6" :style="{fontSize: '1.3em'}">TCF / CONSENT</h2>
                                    <v-row no-gutters v-for="(switches, i) in tcfToggles" :key="'switch_'+i">
                                        <v-col class="label" cols="4">{{ switches.label }}</v-col>
                                        <v-col>
                                            <Toggle
                                                class="ma-0"
                                                v-model="$v[switches.vModel].$model"
                                                :error-messages="switches.errors"
                                            ></Toggle>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col class="label" cols="4">TCF v2: Account Id</v-col>
                                        <v-col>
                                            <Input class="ma-0 pa-0" :style="{maxWidth: '200px'}"
                                                   v-model="cmp_id" :error-messages="cmp_id_errors"
                                                   :required="true"
                                                   @input="$v.cmp_id.$touch()"
                                                   @blur="$v.cmp_id.$touch()">
                                            </Input>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                        </v-row>


                    </form>
                </transition>

                <template #button>
                    <Button :text="true" :disabled="loading" @click="submit" :color="ada.pink"
                            v-bind:loading="loading">
                        Speichern
                    </Button>
                    <Button :text="true" @click="close" :color="ada.darkGrey">Abbrechen</Button>
                </template>
            </Dialog>
        </v-overlay>
        <Snackbar v-model="successSnackbar" color="success">Änderungen erfolgreich gespeichert.</Snackbar>
        <AddSitetypeDialog v-model="showAddSitetypeDialog"></AddSitetypeDialog>
    </div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import {validationMixin} from 'vuelidate'
import {required, numeric, requiredIf} from 'vuelidate/lib/validators'
import Input from "../../../components/Inputs/Input";
import Utils from "../../../scripts/Utils";
import Dropdown from "../../../components/Inputs/Dropdown";
import ada from "../../../scss/ada_colors.scss"
import Snackbar from "../../../components/Snackbar";
import Toggle from "../../../components/buttons/Toggle";
import TooltipIcon from "../../../components/TooltipIcon";
import AddSitetypeDialog from "../../Display/Dialogs/AddSitetypeDialog";
import Button from "../../../components/buttons/Button";

function mustBeTrue() {
    return this.isVideo === 1 || this.isDisplay === 1
}

export default {
    name: "EditSiteDialog",
    components: {Button, AddSitetypeDialog, TooltipIcon, Toggle, Snackbar, Dropdown, Input, Dialog},
    props: ['value'],
    mixins: [validationMixin],
    validations() {
        return {
            name: {required},
            selected_publisher: {required},
            default_sitetype: {requiredIf: requiredIf(() => this.isDisplay === 1)},
            allow_ad_server_fallback: {required},
            default_opt_in: {required},
            is_child_page: {required},
            cmp_enabled: {required},
            cmp_live: {required},
            cmp_id: {required, numeric},
            use_cert: {required},
            env: {mustBeTrue}
        }
    },
    data: () => {
        return {
            styles: {maxWidth: '500px'},
            showAddSitetypeDialog: false,
            loading: false,
            name: null,
            selected_publisher: null,
            default_sitetype: null,
            //use_for_contextual: null,
            allow_ad_server_fallback: null,
            default_opt_in: null,
            is_child_page: null,
            cmp_enabled: null,
            cmp_live: null,
            cmp_id: null,
            use_cert: null,
            publisher_id: null,
            site_id: null,
            type_id: null,
            isDisplay: 0,
            isVideo: 0,
            usesAdaBundle: 0,
            env: null,
            successSnackbar: false,
            opt_in_options: [
                {text: 'OptOut für Neue Nutzer', value: 0},
                {text: 'OptIn für Neue Nutzer', value: 1},
                {text: 'TCF v2', value: 2},
            ],
            ada
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        vuexState() {
            return this.$store.state.settings;
        },
        siteDetails() {
            return this.vuexState.selectedDetails;
        },
        sitetypes() {
            return this.siteDetails ? this.siteDetails.Types : [];
        },
        publisher() {
            return this.$store.state.display.publisher || [];
        },
        formDropdowns() {
            return [];
        },
        formSwitches() {
            return [
                {
                    vModel: 'allow_ad_server_fallback',
                    label: "AdServer Fallback erlauben",
                    errors: this.ad_server_fallback_errors
                },
                {
                    vModel: 'is_child_page',
                    label: "Kinderseite ?",
                    errors: this.is_child_page_errors
                },
                {
                    vModel: 'use_cert',
                    label: "Zertifikat verwenden ?",
                    errors: this.is_child_page_errors
                },
            ];
        },
        tcfToggles() {
            return [
                {
                    vModel: 'cmp_enabled',
                    label: "TCF v2: Laden per GujAd ?",
                    errors: this.cmp_enabled_errors
                },
                {
                    vModel: 'cmp_live',
                    label: "TCF v2 in Live GujAd ?",
                    errors: this.cmp_live_errors
                }]
        },
        name_errors() {
            return Utils.handleError(this, 'name', 'Bezeichnnung ist erforderlich.');
        },
        publisher_errors() {
            return Utils.handleError(this, 'selected_publisher', 'Publisher ist erforderlich.');
        },
        sitetype_errors() {
            return Utils.handleError(this, 'default_sitetype', {requiredIf: 'Default Sitetype ist erforderlich.'});
        },
        ad_server_fallback_errors() {
            return Utils.handleError(this, 'allow_ad_server_fallback', {required: 'AdServer Fallback ist erforderlich.'});
        },
        opt_in_errors() {
            return Utils.handleError(this, 'default_opt_in', {required: 'Optin Verhalten ist erforderlich.'});
        },
        is_child_page_errors() {
            return Utils.handleError(this, 'is_child_page', {required: 'Kinderseite ist erforderlich.'});
        },
        cmp_enabled_errors() {
            return Utils.handleError(this, 'cmp_enabled', {required: 'TCF v2: Laben per GujAd ist erforderlich.'});
        },
        cmp_live_errors() {
            return Utils.handleError(this, 'cmp_live', {required: 'TCF v2 in Live GujAd ist erforderlich.'});
        },
        cmp_id_errors() {
            return Utils.handleError(this, 'cmp_id', {
                required: 'TCF v2: Account Id ist erforderlich.',
                numeric: 'TCF v2: Account Id darf nur aus Zahlen bestehen.'
            });
        },
        use_cert_errors() {
            return Utils.handleError(this, 'use_cert', 'Zertifikat verwenden ist erforderlich.');
        },
        env_errors() {
            return Utils.handleError(this, 'env', {mustBeTrue: 'Umgebung ist erforderlich.'});
        },
        validate() {
            return this.name_errors.length === 0 &&
                this.publisher_errors.length === 0 &&
                this.sitetype_errors.length === 0 &&
                this.ad_server_fallback_errors.length === 0 &&
                this.opt_in_errors.length === 0 &&
                this.is_child_page_errors.length === 0 &&
                this.cmp_enabled_errors.length === 0 &&
                this.cmp_live_errors.length === 0 &&
                this.cmp_id_errors.length === 0 &&
                this.use_cert_errors.length === 0 &&
                this.env_errors.length === 0;
        },
        errorCount() {
            return this.$store.state.errorCount;
        }
    },
    methods: {
        init() {
            if (this.siteDetails && this.siteDetails.Site) {
                this.publisher_id = this.siteDetails.Site.PublisherId;
                this.site_id = this.siteDetails.Site.SiteId;
                this.type_id = this.siteDetails.Current.SitetypeId;
                this.name = this.siteDetails.Site.Name;
                this.selected_publisher = this.publisher.find(x => x.PublisherId === this.publisher_id);
                this.default_sitetype = this.sitetypes.find(x => x.SitetypeId === this.siteDetails.Site.DefaultSiteType);
                this.allow_ad_server_fallback = this.siteDetails.Site.AllowAdServerFallback;
                this.default_opt_in = this.siteDetails.Site.DefaultOptIn;
                this.is_child_page = this.siteDetails.Site.IsChildPage;
                this.cmp_enabled = this.siteDetails.Site.CMPEnabled;
                this.cmp_live = this.siteDetails.Site.CMPLive;
                this.cmp_id = this.siteDetails.Site.CMPId;
                this.use_cert = this.siteDetails.Site.UseCert;
                this.isVideo = this.siteDetails.Site.IsVideo;
                this.isDisplay = this.siteDetails.Site.IsDisplay;
                this.usesAdaBundle = this.siteDetails.Site.UsesAdaBundle;
            } else {
                this.fetchSiteDetails();
            }
        },
        async submit() {
            this.$v.$touch();
            if (this.validate) {
                this.loading = true;
                let data = await this.$store.dispatch('settings/editSite', this.getBody());
                this.loading = false;
                if (data.Status) {
                    this.successSnackbar = true;
                    this.close();
                } else {
                    this.$root.$emit('snackbar', 'Error: Fehler beim Speichern', 'error');
                }
            }
        },
        async fetchSiteDetails() {
            if (this.vuexState.selectedItem && this.vuexState.selectedItem.SiteId) {
                this.loading = true;
                let data = await this.$store.dispatch('settings/fetchSiteDetails', this.vuexState.selectedItem.SiteId);
                this.loading = false;
                if (data.Status) {
                    this.successSnackbar = true;
                    this.close();
                }
            }
        },
        getBody() {
            let ret = {
                Name: this.name,
                publisher_id: this.selected_publisher.PublisherId,
                site_id: this.siteDetails.Site.SiteId,
                isVideo: this.isVideo,
                isDisplay: this.isDisplay,
                PublisherId: this.selected_publisher.PublisherId,
                DefaultOptIn: typeof this.default_opt_in === 'object' ? this.default_opt_in.value : this.default_opt_in,
                IsChildPage: this.is_child_page,
                CMPEnabled: this.cmp_enabled,
                CMPLive: this.cmp_live,
                CMPId: this.cmp_id,
                UseCert: this.use_cert,
                usesAdaBundle: this.usesAdaBundle,
                allowAdServerFallback: this.allow_ad_server_fallback
            };
            if (this.isDisplay === 1) {
                ret.type_id = this.siteDetails.Current.SitetypeId;
                ret.DefaultSiteType = this.default_sitetype.SitetypeId;
            }
            return ret;
        },
        close() {
            this.$store.commit('settings/resetSelected');
            this.init();
            this.$v.$reset();
            this.$emit('input', false);
        }
    },
    watch: {
        siteDetails() {
            if (this.$store.state.settings.activeTab === 'Settings_Sites') this.init();
        },
        isVideo(newValue) {
            this.env = (newValue === 1 || this.isDisplay === 1);
        },
        isDisplay(newValue) {
            this.env = (newValue === 1 || this.isVideo === 1);
        },
        errorCount() {
            this.loading = false;
        }
    }
}
</script>

<style scoped>
.label {
    font-size: 16px;
    position: relative;
    top: 5px;
}

::v-deep .isVideoCbx .v-messages__message {
    display: none !important;
}
</style>